import { useContext } from 'react';
import { AppContext, DeviceType } from '../../context/AppProvider';

export const useApp = () => {
  const {
    appDispatch,
    appState: { deviceType },
  } = useContext(AppContext);

  return {
    isDesktop: deviceType === DeviceType.DESKTOP,
    isMobile: deviceType === DeviceType.MOBILE,
    isTablet: deviceType === DeviceType.TABLET,
    appDispatch,
  };
};
